import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { getID } from "src/libs/utilities"
import { LANDING_TYPE_CONTENT } from "../interfaces"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"

const modal = (): any[] => {
    return [ 
        {
            id: getID("modal"),
            type: LANDING_TYPE_CONTENT.MODAL,
            animated: ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL, 
            "title": "Канцлер",
            "description": "Коренной национальности",
            "content": [
                {
                "text": "Великие вопросы времени решаются не речами и резолюциями большинства, a железом и кровью!",
                "type": "html",
                "className": "w-100 p-5 lead text-center"
                }
            ], 
            "dialogCSS": {},
            "dialogTitleCSS": {},
            "contentCSS": {},
            "portalCSS": {},
            "footerCSS": {},
            "size": DIALOG_SIZE.MINIMAL,
            defaultTitle: "Модальное окно", 
            "defaultDescription": "Маленького размера",
        },
        {
            id: getID("modal"),
            type: LANDING_TYPE_CONTENT.MODAL,
            animated: ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL, 
            "title": "Канцлер",
            "description": "Коренной национальности",
            "content": [
                {
                "text": "Великие вопросы времени решаются не речами и резолюциями большинства, a железом и кровью!",
                "type": "html",
                "className": "w-100 p-5 lead text-center"
                }
            ], 
            "dialogCSS": {},
            "dialogTitleCSS": {},
            "contentCSS": {},
            "portalCSS": {},
            "footerCSS": {},
            "size": DIALOG_SIZE.NORMAL,
            defaultTitle: "Модальное окно", 
            "defaultDescription": "Нормального размера",
        },
        {
            id: getID("modal"),
            type: LANDING_TYPE_CONTENT.MODAL,
            animated: ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL, 
            "title": "Канцлер",
            "description": "Коренной национальности",
            "content": [
                {
                "text": "Великие вопросы времени решаются не речами и резолюциями большинства, a железом и кровью!",
                "type": "html",
                "className": "w-100 p-5 lead text-center"
                }
            ], 
            "dialogCSS": {
                "background-color": "transparent",
                "box-shadow": "none",
                "border": "4px solid #FFFFFF",
                "border-radius": "12px"
            },
            "dialogTitleCSS": {
                "background-color": "transparent",
                "color": "#FFFFFF",
                "font-transform": "uppercase",
                "letter-spacing": "3px",
                "border-bottom": "1px solid #FFFFFF"
            },
            "contentCSS": {
                "color": "#FFFFFF"
            },
            "portalCSS": { },
            "footerCSS": {
                "background-color": "transparent",
                "color": "#FFFFFF"
            },
            "size": DIALOG_SIZE.NORMAL,
            defaultTitle: "Минималистическое окно",  
        },
        {
            id: getID("modal"),
            type: LANDING_TYPE_CONTENT.MODAL,
            animated: ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL, 
            "title": "Бордовое окно",
            "description": "Коренной национальности",
            "content": [
                {
                "text": "Великие вопросы времени решаются не речами и резолюциями большинства, a железом и кровью!",
                "type": "html",
                "className": "w-100 p-5 lead text-center"
                }
            ], 
            "dialogCSS": {
                "background-color": "transparent",
                "box-shadow": "none",
                "border": "4px solid #FFFFFF",
                "border-radius": "12px"
            },
            "dialogTitleCSS": {
                "background-color": "transparent",
                "color": "#FFFFFF",
                "font-transform": "uppercase",
                "letter-spacing": "3px",
                "border-bottom": "1px solid #FFFFFF"
            },
            "contentCSS": {
                "color": "#FFFFFF"
            },
            "portalCSS": {
                "background-color": "#660000"
            },
            "footerCSS": {
                "background-color": "transparent",
                "color": "#FFFFFF"
            },
            "size": DIALOG_SIZE.NORMAL,
            defaultTitle: "Бордовое окно",  
        },
        {
            id: getID("modal"),
            type: LANDING_TYPE_CONTENT.MODAL,
            animated: ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL, 
            "title": "Зелёное окно",
            "description": "Коренной национальности",
            "content": [
                {
                "text": "Великие вопросы времени решаются не речами и резолюциями большинства, a железом и кровью!",
                "type": "html",
                "className": "w-100 p-5 lead text-center"
                }
            ], 
            "dialogCSS": {
                "background-color": "#33493d",
                "box-shadow": "none",
                "border": "4px solid #FFFFFF",
                "border-radius": "12px"
            },
            "dialogTitleCSS": {
                "background-color": "var(--force-contast-color)",
                "color": "var(--force-plain-color)",
                "font-transform": "uppercase",
                "letter-spacing": "3px",
                "border-bottom": "1px solid #FFFFFF",
                "border-radius": "8px 8px 0 0"
            },
            "contentCSS": {
                "color": "#FFFFFF"
            },
            "portalCSS": {},
            "footerCSS": {
                "background-color": "transparent",
                "color": "#FFFFFF"
            },
            "size": DIALOG_SIZE.MINIMAL,
            defaultTitle: "Зелёное окно",  
        },
        {
            id: getID("modal"),
            type: LANDING_TYPE_CONTENT.MODAL,
            animated: ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL, 
            "title": "Серенькое окно с бляшками",
            "description": "Коренной национальности",
            "content": [
                {
                "text": "Великие вопросы времени решаются не речами и резолюциями большинства, a железом и кровью!",
                "type": "html",
                "className": "w-100 p-5 lead text-center"
                }
            ], 
            "dialogCSS": {
                "background-color": "#43474d",
                "border-radius": "0"
            },
            "dialogTitleCSS": {
                "background-color": "var(--force-contast-color)",
                "color": "var(--force-plain-color)",
                "font-transform": "uppercase",
                "letter-spacing": "3px",
                "border-top": "1px solid #FFFFFF",
                "border-bottom": "1px solid #FFFFFF",
                "position": "relative",
                "border-radius": "0",
                "text-align": "center"
            },
            "contentCSS": {
                "color": "#FFFFFF"
            },
            "portalCSS": {},
            "footerCSS": {
                "background-color": "transparent",
                "color": "#FFFFFF",
                "border-top": "1px solid #FFFFFF",
                "border-bottom": "1px solid #FFFFFF",
                "position": "relative",
                "border-radius": "0"
            },
            "titleElementsCSS": {
                "position": "absolute",
                "top": "-4px",
                "left": "calc(50% - 4px)",
                "width": "10px",
                "height": "10px",
                "background-color": "rgb(255 255 255)",
                "transform": "rotate(45deg)"
            },
            "footerElementsCSS": {
                "position": "absolute",
                "bottom": "-4px",
                "left": "calc(50% - 4px)",
                "width": "10px",
                "height": "10px",
                "background-color": "rgb(255 255 255)",
                "transform": "rotate(45deg)"
            },
            "size": DIALOG_SIZE.MINIMAL,
            defaultTitle: "Серенькое окно с бляшками",  
        },
        {
            id: getID("modal"),
            type: LANDING_TYPE_CONTENT.MODAL,
            animated: ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL, 
            "title": "Окно на квоздиках",
            "description": "Коренной национальности",
            "content": [
                {
                "text": "Великие вопросы времени решаются не речами и резолюциями большинства, a железом и кровью!",
                "type": "html",
                "className": "w-100 p-5 lead text-center"
                }
            ], 
                      "dialogCSS": {
            "background-color": "#474436",
            "border-radius": "0"
          },
          "dialogTitleCSS": {
            "background-color": "#35332b",
            "color": "var(--force-plain-color)",
            "font-transform": "uppercase",
            "letter-spacing": "3px",
            "border-top": "1px solid #FFFFFF",
            "position": "relative",
            "border-radius": "0",
            "text-align": "center"
          },
          "contentCSS": {
            "color": "#FFFFFF"
          },
          "portalCSS": {},
          "footerCSS": {
            "background-color": "transparent",
            "color": "#FFFFFF",
            "border-bottom": "1px solid #FFFFFF",
            "position": "relative",
            "border-radius": "0"
          },
          "titleElementsCSS": {
            "position": "absolute",
            "top": "-5px",
            "left": "calc(50% - 4px)",
            "width": "10px",
            "height": "10px",
            "transform": "rotate(45deg)",
            "background-color": "#35332b",
            "border-top": "1px solid #FFFFFF",
            "border-left": "1px solid #FFF"
          },
          "footerElementsCSS": {
            "position": "absolute",
            "bottom": "-5px",
            "left": "calc(50% - 4px)",
            "width": "10px",
            "height": "10px",
            "transform": "rotate(45deg)",
            "background-color": "#43474d",
            "border-bottom": "1px solid #FFFFFF",
            "border-right": "1px solid #FFF"
          },
          "size": "little",
            defaultTitle: "Окно на квоздиках",  
        },
        {
            id: getID("modal"),
            type: LANDING_TYPE_CONTENT.MODAL,
            animated: ANIMATED_STYLE.FADE_IN_UP,
            animated_delay: ANIMATE_DELAY.WATERFALL, 
            "title": "Мутное стекло",
            "description": "Коренной национальности",
            "content": [
                {
                "text": "Великие вопросы времени решаются не речами и резолюциями большинства, a железом и кровью!",
                "type": "html",
                "className": "w-100 p-5 lead text-center"
                }
            ],
            "dialogCSS": {
                "background-color": "#ffffff2b",
                "backdrop-filter": "blur(10px)",
                "border-radius": "50px",
                "border": "2px solid #FFFFFF",
                "box-shadow": "none"
            },
            "dialogTitleCSS": {
                "background-color": "transparent",
                "color": "#000000",
                "font-transform": "uppercase",
                "letter-spacing": "3px",
                "position": "relative",
                "border-radius": "0",
                "text-align": "center",
                "border-bottom": "none",
                "padding-top": "30px",
                "font-size": "66px",
                "text-transform": "uppercase"
            },
            "contentCSS": {
                "color": "#000"
            },
            "portalCSS": {
                "background-color": "#FFFFFF22"
            },
            "footerCSS": {
                "background-color": "transparent"
            },
            "titleElementsCSS": {},
            "footerElementsCSS": {},
            "size": "little",
            defaultTitle: "Мутное стекло",  
        },
        
    ]
}
export default modal